import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import "./interceptor/axios";
import { Toaster } from "react-hot-toast";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import ContextComponent from "./utils/GlobalContext";

// Create a client
export const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ContextComponent>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          {" "}
          <App />
          <Toaster
            toastOptions={{
              style: {
                border: "1px solid gray",
                borderRadius: "4px",
              },
            }}
          />
        </BrowserRouter>
      </QueryClientProvider>
    </ContextComponent>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
